import _WidgetBaseSP from 'more/_WidgetBaseSP';
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './Sale_Main.html?raw';
import on from 'dojo/on';
import "../../WebCalendar_TS/MainProperties/MainProperties";
import MainPropertiesV2 from '../../WebCalendar_TS/MainProperties/MainPropertiesV2';
import CheckBox from '../../../moreCore/UI/CheckBox/CheckBox';
import "../../../moreCore/UI/CheckBox/CheckBox";
import { ToasterHelpers } from "../../../more/Helpers";
import PlanningObjectOperatorEditor from '../../PlanningObjectOperator/PlanningObjectOperatorEditor';
import { WebcalendarTypes } from "../../../moreCore/UI/moreCoreCalendar/WebCalendarTypes";
//import EvBookingEditor = require("../../EvBookingEditor/EvBookingEditor");
//import "../../EvBookingEditor/EvBookingEditor";



class Sale_Main extends compose(_WidgetBaseSP) {

    templateString: any = template;

    private mainProperties: MdsLax<InstanceType<typeof MainPropertiesV2>>;

    private _calendarCreated() {

    }

    showPlanningDetails(item: WebcalendarTypes.WebCalendarItemData_Default): void {

        this.mainProperties.openDefaultDetailView(item); // mal standard aufrufen

        // ... aber erweitern: Daten für den Editor requesten

        let dlg = this.mainProperties.itemView;

        dlg.on("closed", lang.hitch(this, this._onItemDlgCallback));
    }

    private _onItemDlgCallback(result) {
        // normaler Webkalender nutzt kein Callback, wir brauchen es hier damit wir ggf. den Request canceln
    }

    private _onDataLoaded(): void {


    }

    protected _onClick_CalendarCell(data: WebcalendarTypes.CellClickData_Simple) {
        let startTime = data.startTime;
        let endTime = data.endTime;

        this._createPlanningObjectOperator(startTime, endTime);
    }

    private _setupMainPropertes(): void{

        if (this.mainProperties != null) {
            this.mainProperties.destroy();
            this.mainProperties = null;
        }

        this.mainProperties = new MainPropertiesV2();

        this.mainProperties.enablePlanninObjectOperatorCreation = true;

        on(this.mainProperties, "calendarCreated", lang.hitch(this, this._calendarCreated));
        on(this.mainProperties, "loaded", lang.hitch(this, this._onDataLoaded));
        on(this.mainProperties, "calendarCellClicked", lang.hitch(this, this._onClick_CalendarCell));

        this.UiModder.domConstruct.place(this.mainProperties.domNode, this.domNode, "first");

        let detailFct = lang.hitch(this, this.showPlanningDetails);

        this.mainProperties.setMainConfig({
            itemDetails: {
                customItemClickFunction: detailFct
                //requestUrl:
            },
            resourceClickFct: lang.hitch(this, this._onclick_Resource),
            gridDoubleClickFct: lang.hitch(this, this._onDoubleClick),
        });

        this.mainProperties.startup();
        this.mainProperties.on("calendarButtonsSetup", lang.hitch(this, this.handleCustomButtons));
        //this.handleCustomButtons();


        this._preparePanels();
    }
    private _onclick_Resource(resource: WebcalendarTypes.SyncfusionCalendarResource) {
        alert(resource.label);
    }

    private _onDoubleClick(date: Date) {
    }

    private _preparePanels(): void {
        if (!this.mainProperties) {
            return;
        }

        let props = this.mainProperties;
        //props.addTopButton("reload", this.translate("General_Label_Reload"), lang.hitch(this, this._onClickReload), true, false, "fas fa-sync-alt");
    }


    private _onVisibilityChanged(evt) {

    }

    private handleCustomButtons() {
        this.setupReloadButton();
    }

    private setupReloadButton() {
        this.mainProperties.addTopButton("reload", this.translate("General_Label_Reload"), lang.hitch(this, this._onClickReload), false, true, "fas fa-sync-alt");

    }

    private _onClickReload() {
        this.mainProperties.reloadData();
    }

    private checkRoleCreatePlanningObjectOperator() {
        this.hasUserRole(["PlanningObjectOperator_Create", "PlanningObjectOperator_Edit"], lang.hitch(this, this.handleNewPlanningObjectOperatorButton))
    }

    private handleNewPlanningObjectOperatorButton(hasRoles: boolean) {
        if (!hasRoles) return;

        let menu = this.UiModder.domConstruct.create("div", {
            className: "w3-block w3-center paddingSmall",
            //style: "display: flex;flex-direction: column; justiy-content: center; align-items: center;"
        })

        let checkBox = new CheckBox();
        checkBox.setValue(this.mainProperties.enablePlanninObjectOperatorCreation, true);
        checkBox.on("change", lang.hitch(this, this._onChangeEnableCreateByClick));
        checkBox.setLabel(this.translate("PlanningObjectOperator_Label_CreatePlanningObjecOperatorOnClick"))
        checkBox.setType("toggle");
        checkBox.placeAt(menu);

        let createPlanningObjectOperatorBtn = this.UiModder.domConstruct.create("BUTTON", {
            innerHTML: "<i class='fas fa-plus'></i> " + this.translations["WebCalendar_SidebarPane_btnLabel_createPlanningObjectOperator"],
            className: "mds-button-base padding roundest mds-hover-dark primaryBG marginSmall",
            onclick: lang.hitch(this, this._onClickCreatePlanningObjectOperator)
        }, menu);

        this.mainProperties.addCustomPane("planningObjectOperatorEditorPane", this.translations["WebCalendar_SidebarPane_paneLabel_planningObjectOperatorEditor"], menu, "fas fa-calendar-plus");
    }

    private _onChangeEnableCreateByClick(e) {
        this.mainProperties.enablePlanninObjectOperatorCreation = e;
    }

    private _onClickCreatePlanningObjectOperator(dateStart?: Date, dateEnd?: Date) {
        this._createPlanningObjectOperator();
    }

    private _createPlanningObjectOperator(dateStart?: Date, dateEnd?: Date) {
        let editor = new PlanningObjectOperatorEditor();
        editor.on("saved", lang.hitch(this, this._onClickReload));
        editor.on("deleted", lang.hitch(this, this._onClickReload));
        editor.on("afterReady", lang.hitch(this, this._editorSetDates, editor, dateStart, dateEnd));
        editor.setup();
    }

    private _editorSetDates(editor: MdsLax<InstanceType<typeof PlanningObjectOperatorEditor>>, dateStart: Date, dateEnd: Date) {
        editor.setDateStart(dateStart);
        //editor.setDateEnd(dateEnd);
    }


    publishToastMessage(text: string, icon: ToasterHelpers.ToasterIcons = ToasterHelpers.ToasterIcons.none, timeout?: number, extendedMessage?: string): void {
        if (!this.mainProperties) {
            alert(text);
            console.error(text, extendedMessage);
            return;
        }
        this.mainProperties.publishToastMessage(text, icon, timeout, extendedMessage)
    }

    postMixInProperties(): void {
        super.postMixInProperties.apply(this, arguments as any);
    }
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.addSubscription("/Global/VisibilityChange", lang.hitch(this, this._onVisibilityChanged));
    }
    startup(): void {
        super.startup.apply(this, arguments as any);
        //this._isStartup = true;
        //this._continueWithSession();
        //this._checkUrlParameters();
        this._setupMainPropertes();
        this.checkRoleCreatePlanningObjectOperator();
    }

}

export default mdsWidget(Sale_Main);
